import FullScreenLayout from "../components/layout/FullScreenLayout";
import GreetingFullPage from "@/pages/greeting/GreetingFullPage";

export const publicRoute = {
    path: "/",
    element: <FullScreenLayout />,
    children: [
        {
            index: true,
            element: <GreetingFullPage />,
        },
    ],
};
